const isValidProjectName = (projectName: string): boolean => {
  return (
    projectName.length > 0 && /^[-\w \uac00-\ud7ff\u4e00-\u9fa5\u0800-\u4e00]+$/.test(projectName)
  );
};

export { isValidProjectName };
